var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.895508,
    y: 0.728516,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "#CBCBCB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_15785_208500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8955 11.2285C16.8955 11.7495 16.8185 12.251 16.683 12.7285H15.6325C15.8 12.2585 15.8955 11.755 15.8955 11.2285C15.8955 8.74752 13.877 6.72852 11.3955 6.72852C10.5425 6.72852 9.74751 6.97052 9.06801 7.38552L9.99701 8.72852H6.50001L7.57601 5.22852L8.50051 6.56502C9.34251 6.04052 10.33 5.72852 11.3955 5.72852C14.4325 5.72852 16.8955 8.19102 16.8955 11.2285ZM13.7185 15.0745C13.04 15.4875 12.2465 15.7285 11.3955 15.7285C8.91451 15.7285 6.89551 13.7095 6.89551 11.2285C6.89551 10.702 6.99101 10.1985 7.15801 9.72852H6.10801C5.97251 10.206 5.89551 10.7075 5.89551 11.2285C5.89551 14.266 8.35801 16.7285 11.3955 16.7285C12.459 16.7285 13.445 16.418 14.2855 15.895L15.212 17.2285L16.288 13.734H12.791L13.7185 15.0745Z",
    fill: "#55595F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15785_208500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(5.39551 5.22852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.a780b893c4e585ff97e931cfd8dde556.svg";
export { ForwardRef as ReactComponent };